module.exports = __webpack_public_path__ + "img/9788996125068.82a3fd37.jpg";